<template>
	<div>
		<div v-if="queryRes" class="index-container main-w">
			<!-- 证书 -->
			<div class="subject">
				<!-- 证书查询 -->
				<div class="subject-r">
					<!-- 证书头部 -->
					<div class="subject-r-title">
						<div class="certificate-query">
							<img src="../assets/search_icon.png" alt="" />
							<div class="title">证书查询</div>
						</div>
					</div>
					<!-- 证书查询主体 -->
					<div class="subject-r-content">
						<div class="form">
							<el-form :model="formData" :rules="rules" ref="formData">
								<el-form-item prop="idcard"><el-input v-model="formData.idcard" placeholder="请输入身份证号"></el-input></el-form-item>
								<el-form-item prop="cno"><el-input v-model="formData.cno" placeholder="请输入证书编号" @keyup.enter.native="handleQuery"></el-input></el-form-item>
								<el-button :loading="queryLoading" class="query-btn" @click="handleQuery">查询</el-button>
							</el-form>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 证书查询 -->
		<div v-else class="query-container main-w">
			<!-- 面包屑导航 -->
			<Crumbs @toIndex="toIndex">
				<template v-slot:current>
					证书查询
				</template>
			</Crumbs>
			<div class="content">
				<!-- 个人信息 -->
				<div class="content-info">
					<div>
						<div class="label-text name">姓 名</div>
						<span style="margin: 0; color: #666666;">:</span>
						<span>{{ certDetail.username }}</span>
					</div>
					<div>
						<div class="label-text">证书编号</div>
						<span style="margin: 0; color: #666666;">:</span>
						<span>{{ certDetail.cno }}</span>
					</div>
					<div>
						<div class="label-text">证件类型</div>
						<span style="margin: 0; color: #666666;">:</span>
						<span>{{ certDetail.ctype }}</span>
					</div>
					<div>
						<div class="label-text">发证日期</div>
						<span style="margin: 0; color: #666666;">:</span>
						<span>{{ certDetail.posttime }}</span>
					</div>

					<div>
						<div class="label-text">证件号码</div>
						<span style="margin: 0; color: #666666;">:</span>
						<span>{{ certDetail.idcard }}</span>
					</div>
					<div>
						<div class="label-text">发证认证</div>
						<span style="margin: 0; color: #666666;">:</span>
						<span v-if="certDetail.auth" v-html="certDetail.auth"></span>
						<!-- <span v-if="certDetail.vauth" v-html="certDetail.auth"></span> -->
					</div>
					<div>
						<div class="label-text">职业名称</div>
						<span style="margin: 0; color: #666666;">:</span>
						<span>{{ certDetail.cname }}（高级）</span>
					</div>
				</div>
				<div class="content-photo">
					<div class="photo">
						<el-image style="width: 102px; height: 146px" :src="certDetail.userimage" :preview-src-list="[certDetail.userimage]" fit="scale-down"></el-image>
					</div>
					<!-- <div class="certificate">
            <el-image
              style="width: 220px; height: 152px"
              :src="$store.getters.baseImgUrl + certDetail.cimage"
              :preview-src-list="[
                $store.getters.baseImgUrl + certDetail.cimage,
              ]"
              fit="scale-down"
            ></el-image>
          </div> -->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import validate from '@/utils/validate.js';
import More from '@/components/More';
import Crumbs from '@/components/Crumbs';
import { Message } from 'element-ui';

export default {
	components: {
		More,
		Crumbs
	},
	data() {
		return {
			formData: {
				// 证书信息
				idcard: '',
				cno: ''
			},
			adList: [], // banner 列表
			specialList: [], // 证书资讯列表
			topList: [], // 置顶消息
			newsList: {}, // 行业新闻列表
			informList: {}, // 通知公告列表
			newsTitle: '行业新闻',
			informTitle: '通知公告',
			newsMoreText: true, // 查看更多显示/隐藏
			informMoreText: true, // 查看更多显示/隐藏
			certDetail: {}, // 证书悉信息
			queryRes: true, // 证书结果显示/隐藏
			queryLoading: false, // 查询按钮显示/隐藏
			rules: {
				idcard: [{ required: true, message: '请填写身份证号', trigger: 'blur' }, { validator: validate.checkIdcard, trigger: 'blur' }],
				cno: [
					{ required: true, message: '请输入11位证书编号', trigger: 'blur' },
					{
						validator: (rule, value, callback) => {
							if (value.length === 11) {
								callback();
							} else {
								return callback(new Error('请输入11位证书编号'));
							}
						},
						trigger: 'blur'
					}
				]
			}
		};
	},
	methods: {
		// 查询证书
		handleQuery() {
			this.$refs['formData'].validate(valid => {
				if (valid) {
					this.queryLoading = true;
					this.service1('cert/searchCert', this.formData)
						.then(res => {
							if (res.code === 0) {
								Message.error(res.msg);
							} else {
								this.certDetail = res.data;
								Message.success('查询成功');
								this.queryRes = false;
							}
							this.formData = { idcard: '', cno: '' };
							this.$refs['formData'].clearValidate();
						})
						.catch(err => {
							Message.error(err);
						})
						.finally(() => {
							this.queryLoading = false;
						});
				}
			});
		},
		toIndex() {
			this.queryRes = true;
		},

		// 获取banner
		async getAdlist() {
			const { data } = await this.service1('Ad/adList', 'get');
			this.adList = data;
		},
		async toUrl(top) {
			if (top.content === '') {
				window.location.href = top.url;
			} else {
				this.$router.push({ name: 'Detail', params: { id: top.id } });
			}
		},

		// 获取证书资讯
		async getSpecialList() {
			const { data } = await this.service1('News/newsList', { classid: 1, page: 1, pagesize: 6 });
			this.specialList = data.data.filter((item, index) => item.is_top == 0);
			this.topList = data.data.filter((item, index) => item.is_top == 1);
		},
		// 获取行业新闻
		async getNewsList() {
			const { data } = await this.service1('News/newsList', { classid: 2, page: 1, pagesize: 6 });
			this.newsList = data;
		},
		// 获取通知公告
		async getInformList() {
			const { data } = await this.service1('News/newsList', { classid: 3, page: 1, pagesize: 3 });
			this.informList = data;
		},

		// 跳转详情页
		toDetail(id, content, url) {
			if (content === '') {
				this.toUrl(url);
			} else {
				this.$router.push({ name: 'Detail', params: { id: id } });
			}
		}
	},
	created() {
    console.log($store.getters.baseImgUrl)
		// this.getAdlist();
		// this.getSpecialList();
		// this.getNewsList();
		// this.getInformList();
	},
	watch: {
		'$route.path': function(newVal, oldVal) {
			this.formData = { idcard: '', cno: '' };
			this.$refs['formData'].clearValidate();
		}
	}
};
</script>

<style lang="less" scoped>
.index-container {
	.subject {
		margin-top: 50px;
		.subject-r {
			//margin-left: 30px;
			//width: 585px;
			height: 280px;
      margin-bottom: 120px;
			.subject-r-title {
				display: flex;
				justify-content: space-between;
				position: relative;
				height: 35px;
				border-bottom: 1px solid #d1d1d1;
				.certificate-query {
					position: relative;
					top: 1px;
					width: 137px;
					padding-right: 40px;
					display: flex;
					border-bottom: 2px solid #017575;
					img {
						width: 24px;
						height: 24px;
						margin-top: 3px;
					}
					.title {
						margin-left: 15px;
						font-size: 24px;
						font-weight: bold;
						color: #017575;
					}
				}
				.certificate-link {
					line-height: 36px;
					color: #999999;
					font-size: 18px;
				}
			}
			.subject-r-content {
				padding: 30px 50px 0;
				.form {
					position: relative;
					box-sizing: border-box;
          left: 50%;
          transform: translateX(-50%);
          max-width: 450px;
					height: 218px;
					padding: 23px 60px 0;
					background: #f2f4f7;
					border: 1px solid #dddddd;
					.query-btn {
						position: absolute;
						left: 50%;
						transform: translateX(-50%);
						width: 102px;
						height: 48px;
						margin: 0 auto;
						background: #007475;
						text-align: center;
						color: #fff;
						font-size: 18px;
					}
				}
			}
		}
	}
}
.query-container {
	padding: 10px 23px;
	box-sizing: border-box;
	background-color: #fff;
	.content {
		padding: 0 102px;
		display: flex;
		margin-top: 95px;
		margin-bottom: 45px;
		align-items: flex-start;
		.content-info {
			flex: 3;
			display: flex;
			flex-wrap: wrap;
			div {
				display: flex;
				width: 50%;
				// margin: 10px 0;
				height: 65px;
				color: #666666;
				.label-text {
					font-size: 18px;
					font-weight: 500;
					display: inline-block;
					text-align: justify;
					text-justify: distribute-all-lines;
					text-align-last: justify;
					text-indent: 10px;
					width: 88px;
				}
				span {
					margin-left: 20px;
					color: #333333;
					font-size: 18px;
					font-weight: 500;
				}
			}
		}
		.content-photo {
			flex: 1;
			display: flex;
			flex-direction: column;
			align-items: center;

			.certificate {
				margin-top: 20px;
			}
		}
	}
}
</style>
